<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增咨询商</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="guanli">
					<Button type="primary" size="small" style="margin-right: 5px" :to="'/supplier/news/option?id='+row.id+'&name='+row.supplierName">咨询管理</Button>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status==1" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">停用</Button>
					<Button v-if="row.status==0" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addStoreShow" :title="addForm.id?'编辑应用市场':'新增应用市场'">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="供应商名称" prop="supplierName">
					<Input v-model="addForm.supplierName" placeholder="请输入市场名称"></Input>
				</FormItem>
				<FormItem label="供应商key" prop="supplierKey">
					<Input v-model="addForm.supplierKey" placeholder="请输入市场编码"></Input>
				</FormItem>
				<FormItem label="状态" prop="status">
					<i-switch v-model="addForm.status" size="large">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateData">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				addForm: {
					supplierName: '',
					supplierKey: '',
					status: true,
				},
				addRule: {
					supplierName: [
						{ required: true, message: '请输入供应商名称', trigger: 'blur' }
					],
					supplierKey: [
						{ required: true, message: '请输入供应商key', trigger: 'blur' },
					],
					status: [
						{ required: true, type: 'boolean', message: '请选择状态', trigger: 'blur' }
					],
				}
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '供应商名称',
						key: 'supplierName',
						align: 'center'
					},
					{
						title: '供应商key',
						key: 'supplierKey',
						align: 'center'
					},
					{
						title: '状态',
						key: 'status',
						align: 'center',
						render: (h, params) => {
							return h('span', params.row.status == 1 ? '启用' : '停用');
						}

					}, {
						title: '创建日期',
						key: 'createTime',
						align: 'center'
					},
					{
						title: '管理',
						slot: 'guanli',
						width: 200,
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1,
					this.queryData = []
				this.getData()
			},
			getData() {
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize
				}
				api.statistics
					.getNewsSupplierPage(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateData() {
				const that = this
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						let params = { ...that.addForm }
						params.status = params.status ? 1 : 0
						api.statistics
							.addOrEditNewsSupplier(params)
							.then(res => {
								that.$Message.success('Success!');
								if (that.addForm.id) {
									//编辑
									that.queryData.forEach(item => {
										if (item.id == that.addForm.id) {
											item.status = that.addForm.status
											item.supplierName = that.addForm.supplierName
											item.supplierKey = that.addForm.supplierKey
										}
									})
								} else {
									//新增
									that.refreshData()
								}
								that.addStoreShow = false
							})
							.catch(err => {
								that.$Message.error('新增失败: ' + err.message)
							})

					}
				})
			},

			updateStatus(id, status) {
				const that = this
				api.statistics
					.addOrEditAdvertSupplier({ 'id': id, status: status })
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			addShow() {
				this.addForm = {
					supplierName: '',
					supplierKey: '',
					status: true,
				}
				this.addStoreShow = true
			},
			editData(rowData) {
				this.addForm = {
					id: rowData.id,
					supplierName: rowData.supplierName,
					supplierKey: rowData.supplierKey,
					status: rowData.status == 1 ? true : false
				}
				this.addStoreShow = true

			}
		},



	}
</script>
